
export const common = {
  languageSelector: {
    label: "Nyelv",
    hu: "Magyar",
    en: "Angol",
    de: "Német",
    pl: "Lengyel",
    cs: "Cseh", 
    es: "Spanyol",
    fr: "Francia",
    ro: "Román",
    nl: "Holland",
    pt: "Portugál",
    sv: "Svéd",
    da: "Dán",
    no: "Norvég",
    fi: "Finn",
    lt: "Litván",
    bg: "Bolgár",
    hr: "Horvát",
    at: "Osztrák",
    it: "Olasz"
  },
  buttons: {
    getStarted: "Kezdés",
    learnMore: "Tudj meg többet",
    login: "Bejelentkezés"
  },
  terms: "ÁSZF",
  aboutUs: "Rólunk",
  newsletter: "Hírlevél",
  newsletterDescription: "Iratkozz fel a hírlevélre és értesülj elsőként az újdonságokról!",
  emailPlaceholder: "Add meg az email címed",
  subscribe: "Feliratkozás",
  affiliateProgram: "Ajánlói program",
  copyright: "© 2025 Bespire. Minden jog fenntartva.",
  madeWithLove: "Készítve ❤️-vel alkotóknak",
  systemStatus: "Rendszer állapot: Működik",
  termsOfService: "Általános szerződési feltételek hamarosan!",
  logoAlt: "Bespire Logo"
};
